const route = {
	name: 'new-quotation',
	path: '/new-quotation',
	meta: {
		title: 'Cotización',
	},
	// component: () => import('@/components/quotation/new-quotation'),
	component: () => import('@/components/sales/new-sale'),
};

export default route;



// WEBPACK FOOTER //
// ./src/router/new-quotation.js